export const firebaseConfig = {
  apiKey: 'AIzaSyAuLUYRiJzyW3OAH69HZ1ySKEA5NYmCMS4',
  authDomain: 'ippd-data-story.firebaseapp.com',
  databaseURL: 'https://ippd-data-story.firebaseio.com',
  projectId: 'ippd-data-story',
  storageBucket: 'ippd-data-story.appspot.com',
  messagingSenderId: '990221446659',
  appId: '1:990221446659:web:3b73c5da90a0fba4c42836',
};
